import '../styles/SmallDice.css';

function SmallDice({ die, isSelected, onSelect, isClickable }) {
  // Map die values to rotations for 3D cube
  const rotationMap = {
    0: { x: 0, y: 0 },
    1: { x: 0, y: 0 },
    2: { x: 0, y: -90 },
    3: { x: 0, y: 90 },
    4: { x: 0, y: 180 },
    5: { x: -90, y: 0 },
    6: { x: 90, y: 0 }
  };

  const rotation = rotationMap[die.value] || { x: 0, y: 0 };

  // Determine dot color - black for white/light dice, white for dark dice
  const dotColor = die.color === '#FFFFFF' ? '#000000' : '#FFFFFF';

  return (
    <div
      className={`small-dice-wrapper ${isClickable ? 'clickable' : ''} ${isSelected ? 'selected' : ''}`}
      onClick={isClickable ? onSelect : undefined}
    >
      <div
        className="small-dice"
        style={{
          transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`
        }}
      >
        {/* Face 1 - 1 dot */}
        <div className="small-dice-face front" style={{ backgroundColor: die.color }}>
          <div className="dots-container">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 2 - 2 dots */}
        <div className="small-dice-face right" style={{ backgroundColor: die.color }}>
          <div className="dots-container two-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 3 - 3 dots */}
        <div className="small-dice-face left" style={{ backgroundColor: die.color }}>
          <div className="dots-container three-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 4 - 4 dots */}
        <div className="small-dice-face back" style={{ backgroundColor: die.color }}>
          <div className="dots-container four-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 5 - 5 dots */}
        <div className="small-dice-face top" style={{ backgroundColor: die.color }}>
          <div className="dots-container five-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>

        {/* Face 6 - 6 dots */}
        <div className="small-dice-face bottom" style={{ backgroundColor: die.color }}>
          <div className="dots-container six-dots">
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
            <div className="dot" style={{ backgroundColor: dotColor }}></div>
          </div>
        </div>
      </div>
      <div className="small-dice-label">{die.value}</div>
    </div>
  );
}

export default SmallDice;

